import { FC } from 'react';
import {
  Element,
  ElementWrapper,
  ContainerWrapper,
} from 'containers/CourtManagerAssignedExpertise/style';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerAssignedExpertise/messages';
import { injectIntl, IntlShape } from 'react-intl';

interface VehiclesProps {
  intl: IntlShape;
  registrationNumbers: string[];
}

const renderRegistrationNumber = (registrationNumbers: string[]) => {
  return registrationNumbers.map(registrationNumber => (
    <ElementWrapper>
      <Element elevation={3}>{registrationNumber}</Element>
    </ElementWrapper>
  ));
};

const Vehicles: FC<VehiclesProps> = props => {
  const { registrationNumbers } = props;
  return (
    <ContainerWrapper>
      <h2>{translate(messages.vehicles, props)}</h2>
      {renderRegistrationNumber(registrationNumbers)}
    </ContainerWrapper>
  );
};

export default injectIntl(Vehicles);
